import React from 'react';
import HarbourPathwayMark from './HarbourPathwayMark';
import HarbourStatusChip from './HarbourStatusChip';
import HarbourTextLink from './HarbourTextLink';
import './harbour.css';

/*
 * Harbour/Pathway lane: one pathway block on a pupil card. Active lanes show
 * the stage word and work rows; inactive lanes show the muted "Not active"
 * panel with the add link. When no onAdd handler is supplied the add link is
 * omitted entirely — the UI never offers an action the system cannot deliver.
 */
const PATHWAY_NAMES = { sen: 'SEND pathway', referral: 'Referral pathway' };

export default function HarbourPathwayLane({ pathway, active, stage, rows = [], extraChips = [], onAdd, addLabel }) {
  const tone = pathway === 'sen' ? 'sen' : 'referral';
  return (
    <div className="harbour-lane">
      <div className="harbour-lane__eyebrow">
        <HarbourPathwayMark pathway={pathway} />
        {PATHWAY_NAMES[pathway]}
      </div>
      {active ? (
        <div className="flex flex-col gap-2">
          {stage && <div className={`harbour-lane__stage harbour-lane__stage--${tone}`}>{stage}</div>}
          {rows.map((row) => (
            <div key={row.key || row.label} className="harbour-lane__row">
              {row.label ? (
                <span className={row.emphasis ? 'harbour-lane__row-name' : 'harbour-lane__row-label'}>
                  {row.label}
                </span>
              ) : null}
              <HarbourStatusChip
                status={row.chip.status}
                label={row.chip.label}
                tone={row.chip.tone || tone}
              />
            </div>
          ))}
          {extraChips.map((chip) => (
            <div key={chip.status + (chip.label || '')}>
              <HarbourStatusChip status={chip.status} label={chip.label} tone={chip.tone || tone} />
            </div>
          ))}
        </div>
      ) : (
        <div className="harbour-lane__not-active">
          <span>Not active</span>
          {onAdd && (
            <HarbourTextLink leadingIcon="plus" onClick={onAdd}>
              {addLabel || `Add to ${PATHWAY_NAMES[pathway]}`}
            </HarbourTextLink>
          )}
        </div>
      )}
    </div>
  );
}
